import EyeButton from 'pages/Ui/EyeButton/EyeButton'
import React from 'react'
import styled from 'styled-components'

const Category = styled.div`
  border: 1.5px solid #94a3b8;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 10px;
`

const NotifHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;
`

const TitleWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
`

const Title = styled.span`
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
`

const ToggleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const ToggleStatus = styled.span`
  font-size: 0.76rem;
  font-weight: 700;
  color: ${({ $on }) => ($on ? '#2e9e3f' : '#64748b')};
  min-width: 24px;
  text-align: right;
`

const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 42px;
  height: 24px;
  flex-shrink: 0;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
`

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: ${({ $checked }) =>
    $checked ? '#2e9e3f' : '#cbd5e1'};
  border: 1.5px solid #94a3b8;
  transition: 0.2s;
  border-radius: 24px;

  &::before {
    content: '';
    position: absolute;
    height: 18px;
    width: 18px;
    left: ${({ $checked }) =>
      $checked ? '21px' : '3px'};
    bottom: 3px;
    background: #fff;
    transition: 0.2s;
    border-radius: 50%;
  }
`

const SubOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin: 8px 0;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
`

const SubOption = styled.label`
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 0.84rem;
  color: #334155;

  input {
    width: 15px;
    height: 15px;
    accent-color: #0d47a1;
  }
`

const EmailFieldWrap = styled.div`
  margin-top: 2px;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

  input[type='text'] {
    width: 100%;
    padding: 7px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 0.85rem;
    font-family: inherit;
    background: #eaf4fd;

    &:disabled {
      background: #f1f5f9;
      color: #94a3b8;
    }
  }
`

const HelperText = styled.div`
  font-size: 0.72rem;
  color: #64748b;
  margin-top: 3px;
`

const NotificationBox = ({
  id,
  title,
  infoText,
  options = [],

  enabled = false,
  selectedOptions = [],
  email = '',
  disabled,
  onChange,
}) => {

  const handleToggle = (checked) => {
    onChange?.({
      id,
      enabled: checked,
      selectedOptions,
      email,
    })
  }

  const handleOptionChange = (option, checked) => {

    const nextOptions = checked
      ? [...selectedOptions, option]
      : selectedOptions.filter(
          (item) => item !== option
        )

    onChange?.({
      id,
      enabled,
      selectedOptions: nextOptions,
      email,
    })
  }

  const handleEmailChange = (value) => {

    onChange?.({
      id,
      enabled,
      selectedOptions,
      email: value,
    })
  }

  return (
    <Category>

      <NotifHead>

        <TitleWrap>

          <Title>
            {title}
          </Title>

          <EyeButton message={infoText} />

        </TitleWrap>

        <ToggleGroup>

          <ToggleStatus $on={enabled}>
            {enabled ? 'On' : 'Off'}
          </ToggleStatus>

          <Switch>

            <input
              type="checkbox"
              checked={enabled}
              disabled={disabled}
              onChange={(e) =>
                handleToggle(e.target.checked)
              }
            />

            <Slider $checked={enabled} />

          </Switch>

        </ToggleGroup>

      </NotifHead>


      {options.length > 0 && (

        <SubOptions $disabled={!enabled}>

          {options.map((option) => (

            <SubOption key={option.id ?? option}>

              <input
                type="checkbox"
                checked={selectedOptions.includes(
                  option.id ?? option
                )}
                disabled={!enabled || disabled}
                onChange={(e) =>
                  handleOptionChange(
                    option.id ?? option,
                    e.target.checked
                  )
                }
              />

              {option.name ?? option.label ?? option}

            </SubOption>

          ))}

        </SubOptions>

      )}


      <EmailFieldWrap $disabled={!enabled}>

        <input
          type="text"
          placeholder="email1@company.com; email2@company.com"
          value={email}
          disabled={!enabled || disabled}
          onChange={(e) =>
            handleEmailChange(e.target.value)
          }
        />

        <HelperText>
          Separate multiple email addresses with a semicolon ( ; )
        </HelperText>

      </EmailFieldWrap>

    </Category>
  )
}

export default NotificationBox